export default "__VITE_ASSET__tVMO9uQg__"